<script lang="ts">
	import { Icon } from '@enzianweb/shared';
	import { onMount } from 'svelte';
	import { _ } from 'svelte-i18n';
	import { fade } from 'svelte/transition';

	const localStorageKey = 'versionInfo';
	const version = import.meta.env.VITE_BUILD_VERSION;
	let showNewVersionInformation: boolean = false;

	onMount(() => {
		//Load the last version
		let lastKnownVersion = localStorage.getItem(localStorageKey);

		if (lastKnownVersion != version) {
			showNewVersionInformation = true;
		}
	});
</script>

{#if showNewVersionInformation}
	<div class="bg-white dark:bg-dark-200 rounded flex shadow-lg items-center" transition:fade>
		<div class="icon flex items-center rounded-l bg-primary-100 dark:bg-secondary-500 px-2 py-6">
			<Icon name="exclamation" classInfo="fill-white" />
		</div>

		<div class="px-4 grow">
			<p class="font-bold">
				{$_('version.lbl_new_version_header').replace('{}', version)}
			</p>

			<p class="">
				{$_('version.lbl_new_version_text')}
				<a
					href={import.meta.env.VITE_RELEASE_NOTES_URL}
					target="_blank"
					class="text-secondary-200 dark:text-secondary-500"
				>
					{$_('version.link_release_notes_link')}
				</a>
			</p>
		</div>

		<button
			class="p-4"
			on:click={() => {
				//Set the cookie back to the browser
				localStorage.setItem(localStorageKey, version);
				//Close the modal
				showNewVersionInformation = false;
			}}
		>
			<Icon name="xmark" classInfo="dark:fill-white"></Icon>
		</button>
	</div>
{/if}
